<script>
import { get } from 'lodash'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      itemOptions: [
        {
          label: 'Zdjęcie',
          value: 'image'
        },
        {
          label: 'Film YouTube',
          value: 'youtube'
        }
      ]
    }
  },
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.items)) {
        this.$set(this.form, 'items', [])
      }
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Header({
              type: 'h3',
              text: 'Elementy galerii'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((itemGallery, i) => {
                return {
                  headerLabel: 'Element galerii',
                  fields: [
                    new fields.Select({
                      label: 'Typ',
                      modelPath: [this, 'form', 'items', i, 'type'],
                      options: this.itemOptions,
                      required: true
                    }),
                    new fields.Input({
                      label: 'Link do YouTube',
                      modelPath: [this, 'form', 'items', i, 'youtube_url'],
                      required: true,
                      condition:
                        get(this, ['form', 'items', i, 'type']) === 'youtube'
                    }),
                    new fields.Image({
                      label: 'Zdjęcie',
                      modelPath: [this, 'form', 'items', i, 'image'],
                      required: true,
                      condition:
                        get(this, ['form', 'items', i, 'type']) === 'image'
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
